import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'facility_has_not_performed_asbestos_exposure_assessment'

export const dataPointDefinition = {
  retracedId: 'facility_has_not_performed_asbestos_exposure_assessment',
  name: 'Facility has not performed an asbestos exposure assessment',
  description:
    'Regardless of whether Asbestos Containing Material (ACM) is present or not, the facility either has or has not performed an asbestos exposure risk assessment (exposure to building materials and/or products). ',
  meta: {
    slcpMeta: {
      key: 'hs-bui-56x',
      number: 'HS-BUI-16-1',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-bui-56x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29830,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
